module.exports = __webpack_public_path__ + "imgesssyaa/svg/Share.2b9206d4.svg";